import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface WithAuthProps {
    children: ReactNode;
}

export const WithAuth: React.FC<WithAuthProps> = ({ children }) => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        if (isAuthenticated === false) {
            navigate('/login');
        }
    }, [navigate, isAuthenticated]);

    if (isAuthenticated !== true) {
        return null;
    }

    return <>{children}</>;
};
